import React, { useLayoutEffect, useState } from 'react';
import { isBrowser } from 'react-device-detect';
import { Link, Outlet } from 'react-router-dom';

import BotaoLink from 'Component/BotaoLink';
import Imagem from 'Component/Imagem';
import RolarParaTopo from 'Component/RolarParaTopo';

import type { Props } from './index';

const Login = (props: Props): React.ReactElement => {
  const [fundo, setFundo] = useState<boolean>(false);

  useLayoutEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30 && !fundo) {
        setFundo(true);
      } else {
        setFundo(false);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-black d-flex mh-100 flex-nowrap bg-light animate__animated animate__fadeIn">
      <div className="w-100 d-flex flex-column overflow-auto">
        <nav
          id="navbar-top"
          className={[
            'navbar navbar-expand-lg navbar-dark',
            'tl-background-color tl-opacity',
            fundo && 'bg-gray bg-opacity-75 bd-filter-blur-1',
            'fixed-top top-0 z-index-5000',
            'w-100',
            'pb-0 px-0 px-sm-3',
            'animate__animated',
            'animate__slideInDown',
          ].class()}
        >
          <div className="container-fluid mx-3 mx-sm-4 py-2 fs-4 fw-lighter">
            <span className="navbar-brand" style={{ flex: 1 }}>
              <Link to="/">
                <Imagem
                  src="logo.webp"
                  height={isBrowser ? 40 : 30}
                  className="p-0"
                />
              </Link>
            </span>

            <ul className="navbar-nav d-flex flex-row justify-content-end">
              {/* <BrowserView renderWithFragment>
                <li className="nav-item">
                  <BotaoLink tema="outline-light" to="/cadastrar">
                    Cadastrar-se
                  </BotaoLink>
                </li>
              </BrowserView> */}
              <li className="nav-item ms-2">
                <BotaoLink to="/login">Acessar minha conta</BotaoLink>
              </li>
            </ul>
          </div>
        </nav>
        <div style={{ height: 100 }}></div>
        <section className="d-flex flex-column flex-grow-1">
          <RolarParaTopo />
          {props.children}
          <Outlet />
        </section>
        <div style={{ marginBottom: '67px' }} />
      </div>
    </div>
  );
};

export default Login;
